/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

import {
  CountryCode,
  CreateRepresentativeRequest,
  PaginatedRepresentativeDto,
  RenewRepresentativeContractRequest,
  RepresentativeDto,
  UpdateRepresentativeRequest,
} from "../__ignore/schemas";

/**
 * @summary Get representative
 */
export const getRepresentativeQueryIncludeDeletedDefault = false;

export const GetRepresentativeQueryParams = zod.object({
  includeDeleted: zod.coerce.boolean().default(getRepresentativeQueryIncludeDeletedDefault),
});

export const GetRepresentativeResponse = RepresentativeDto;

/**
 * @summary Update representative
 */
export const UpdateRepresentativeBody = UpdateRepresentativeRequest;

export const UpdateRepresentativeResponse = zod.void();

/**
 * @summary Delete representative
 */
export const DeleteRepresentativeResponse = zod.void();

/**
 * @summary List representatives
 */

export const listRepresentativesQueryPerPageMax = 100;

export const listRepresentativesQuerySortKeyDefault = `representativeId`;
export const listRepresentativesQueryStateDefault = `ACTIVE`;
export const listRepresentativesQueryContractStatusDefault = `ALL`;

export const ListRepresentativesQueryParams = zod.object({
  page: zod.coerce.number().int().min(1).describe("Page number (1-indexed)"),
  perPage: zod.coerce
    .number()
    .int()
    .min(1)
    .max(listRepresentativesQueryPerPageMax)
    .describe("Number of items per page"),
  q: zod.coerce
    .string()
    .optional()
    .describe(
      "Case-insensitive substring search across Representative company name or normalized company ID",
    ),
  sortKey: zod
    .enum(["representativeId", "companyName"])
    .default(listRepresentativesQuerySortKeyDefault)
    .describe("Representative sort key"),
  sortDir: zod.enum(["asc", "desc"]).optional().describe("Sort direction"),
  state: zod
    .enum(["ACTIVE", "DELETED", "ALL"])
    .default(listRepresentativesQueryStateDefault)
    .describe("Representative state filter"),
  contractStatus: zod
    .enum(["EFFECTIVE", "EXPIRED", "ALL"])
    .default(listRepresentativesQueryContractStatusDefault)
    .describe("Representative contract status filter"),
  countryCodes: zod.array(CountryCode).optional().describe("Representative country filter"),
  exclusive: zod.coerce.boolean().optional().describe("Representative exclusivity filter"),
  createdFrom: zod.iso.datetime({offset: true}).optional().describe("Inclusive creation timestamp"),
  createdBefore: zod.iso
    .datetime({offset: true})
    .optional()
    .describe("Exclusive creation timestamp"),
});

export const ListRepresentativesResponse = PaginatedRepresentativeDto;

/**
 * @summary Create representative
 */
export const CreateRepresentativeBody = CreateRepresentativeRequest;

export const CreateRepresentativeResponse = zod.uuid();

/**
 * @summary Restore representative
 */
export const RestoreRepresentativeResponse = zod.void();

/**
 * @summary Renew representative contract
 */
export const RenewRepresentativeContractBody = RenewRepresentativeContractRequest;

export const RenewRepresentativeContractResponse = zod.void();
